import { MIXPANEL_EVENT_PROPERTIES } from '../../constants';
import { SimpleStore } from '../simple';

type Options = {
    disableErrorLogging: boolean;
};

export const createVariationIdStore = (
    { disableErrorLogging = false }: Options = {
        disableErrorLogging: false,
    }
) =>
    new SimpleStore<typeof MIXPANEL_EVENT_PROPERTIES.VARIATION_ID, string>(
        MIXPANEL_EVENT_PROPERTIES.VARIATION_ID,
        {
            disableErrorLogging,
        }
    );
